import React from 'react';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePreRegisteredAccommodationExport } from '../hooks/usePreRegisteredAccommodationExport';
import type { PreRegisteredAccommodationExportParams } from '../types/pre-registration.types';

interface ExportPreRegistrationsButtonProps {
  params: PreRegisteredAccommodationExportParams;
}

export const ExportPreRegistrationsButton: React.FC<ExportPreRegistrationsButtonProps> = ({ params }) => {
  const { exportToExcel, isExporting } = usePreRegisteredAccommodationExport();

  return (
    <Button variant="outline" onClick={() => exportToExcel(params)} disabled={isExporting}>
      {isExporting ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <FileSpreadsheet className="mr-2 h-4 w-4" />
      )}
      {isExporting ? 'Exportando...' : 'Exportar a Excel'}
    </Button>
  );
};
